import { render } from "./UserRecoverPasswordView.vue?vue&type=template&id=5bbaa3ee&scoped=true"
import script from "./UserRecoverPasswordView.vue?vue&type=script&lang=js"
export * from "./UserRecoverPasswordView.vue?vue&type=script&lang=js"

import "./UserRecoverPasswordView.vue?vue&type=style&index=0&id=5bbaa3ee&lang=scss&scoped=true"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbaa3ee"]])

export default __exports__